import type { TransactionEIP7702Type } from "./TransactionEIP7702Type.js";

/**
 * Branded EIP-7702 Transaction type (alias for TransactionEIP7702Type)
 */
export type BrandedTransactionEIP7702 = TransactionEIP7702Type;
